import React from 'react'

export default function Footer() {
  return (
    <footer>
        <p>Designed by <span className="designed-name">Adarsh Maurya</span></p>
    </footer>
  )
}
